import { useEffect, useRef, useState } from 'react'
import { useClientRequest } from 'hooks/useClientRequest.hook'

export const useFormControl = ({  initialScheme, id }) => {
    const { getAjaxContent, getFormScheme } = useClientRequest()
    const [submitLoading, setSubmitLoading] = useState(false)
    const [refreshLoading, setRefreshLoading] = useState(false)
    const [scheme, setScheme] = useState(initialScheme)
    const [success, setSuccess] = useState(false)

    const { remote } = scheme || {}

    // const url = `/forms/${formCode}`

    useEffect(() => {
        ;(async () => {
            if (!initialScheme && id) {
                const {result} = await getFormScheme(remote || id)
                setScheme(result)
            }
        })()
    }, [id])

    const resetScheme  = () => {
        setScheme(null)
    }

    const onSubmit = async ({ data, formValues, action = 'submit' }) => {
        action == 'submit' ? setSubmitLoading(true) : setRefreshLoading(true)

        let formData
        let result = {
            ...(formValues && { ...formValues }),
            location: window.location.pathname,
            action,
        }

        if (data instanceof FormData) {
            formData = data
            for (const [prop, value] of formData) {
                if (value === 'on') {
                    formData.delete(prop)
                    formData.append(prop, 'Y')
                }
            }
        } else {
            formData = new FormData()
            const santize = Object.entries(data).reduce((acc, [prop, value]) => {
					 const [field, id] = prop.split('_');
                value = value === true ? 'Y' : value === false ? 'N' : value
                value = value === undefined ? 'false' : value
                if (value !== '') {
                    acc[`${field}[${id}]`] = value
                }

                return acc
            }, {})
            result = {
                ...result,
                ...santize,
            }
        }

        for (var key in result) {
            if (Array.isArray(result[key])) {
                Array.from(result[key]).forEach((item, index) => {
						 if(item){
							formData.append(`${key}[${index}]`, item)
						 }
                
                })
            } else {
                formData.append(key, result[key])
            }
        }

        const updData = await getAjaxContent('/slam.form.add', formData)

		  setSubmitLoading(false)

		  return updData;

        setScheme(updData)
        action == 'submit' ? setSubmitLoading(false) : setRefreshLoading(false)
        if(updData.success){
            setSuccess(updData)
        }
        return updData
    }

    return {
        onSubmit,
        submitLoading,
        refreshLoading,
        scheme,
        success,
        setSuccess,
        setScheme,
        resetScheme,
    }
}
